//# вказати header ._fixed
//# при скролі додає в header ._scrolled
//# створює змінну в css - [--headerHeight]
//# добавити - .wrapper { padding-top: var(--headerHeight); }

fixedHeader()
function fixedHeader() {
  const header = document.querySelector('.header')
  const body = document.querySelector('body')

  if (!header) return

  window.addEventListener('scroll', scroll)

  let scrolled = false
  let height

  scroll()
  function scroll() {
    const scrollTop = document.documentElement.scrollTop
    height = header.offsetHeight

    if (scrollTop > 1 && !scrolled) {
      if (header.classList.contains('_fixed')) {
        header.classList.add('_scrolled')
      }

      height = header.offsetHeight
      scrolled = !scrolled
    } else if (scrollTop <= 1 && scrolled) {
      if (header.classList.contains('_fixed')) {
        header.classList.remove('_scrolled')
      }

      height = header.offsetHeight
      scrolled = !scrolled
    }
    body.style.cssText = `--headerHeight: ${height ? height / 16 : 0}rem;`
    window.headerHeight = header.offsetHeight
  }
}
